import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

// services
import { track } from 'services/analytics';
import { EVENTS, SOURCES } from 'services/analytics-constants';

const Container = styled.div`
  max-width: 60%;
  padding: 20px;
  margin: 0 auto;
`;

// TODO: Refactor into shared Header Component
const Tagline = styled.h1`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  margin: 45px 0;
  text-align: center;
`;

const SubHeader = styled.h2`
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 26px;
`;

// TODO: Refactor into shared Text Component
const Text = styled.p`
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  font-size: 20px;
  line-height: 30px;
  text-align: justify;
`;

// TODO: Refactor this into a reusable import
const StyledLink = styled(Link)`
  text-decoration: none;
  color: #d33339;
  font-weight: 500;
`;

const StyledAnchor = StyledLink.withComponent('a');

export default function About(props) {
  return (
    <Container>
      <Tagline>
        Keeping a record of the Trump Era so future generations don't accuse us
        of making it up.
      </Tagline>
      <SubHeader>What is the Trump Capsule</SubHeader>
      <Text>
        A time capsule for the Trump Era. Check in every day to learn what
        insane thing Trump did that day in history. Some you will remember,
        others you've probably already forgotten, and - given this president's
        sheer level of lunacy - many will be completely new to you.
      </Text>

      <SubHeader>What's the Point?</SubHeader>
      <Text>
        One of Donald Trump's most important tactics is the creation of so much
        chaos that most people simply end up tuning it out. Stepping on a nail
        hurts, but stepping on a bed of nails is just an annoyance. By
        documenting the daily parade of insanity from the Trump Administration,
        we hope to remind the American people that none of this is normal. All
        presidents make mistakes and all presidents end up doing things we don't
        like, but we have never witnessed a president like this before.
      </Text>

      <SubHeader>This is so depressing. How can I make it stop?</SubHeader>
      <Text>
        Head over to our{' '}
        <StyledLink
          onClick={() =>
            track(EVENTS.CLICK_TAKE_ACTION, {
              source: SOURCES.ABOUT
            })
          }
          to="/take-action"
        >
          take action page
        </StyledLink>. There you can register to vote, donate to causes Trump
        hates, and get more information on how you can make this country a
        better place even if the president isn't.
      </Text>

      <SubHeader>I love this! How can I help? </SubHeader>
      <Text>
        Share! Share! Share! Don't let your friends fall victim to Trump's white
        noise machine of chaos. Remind them that none of this is normal by
        sharing the most insane Trump Capsule moments on social media.
      </Text>

      <SubHeader>
        You missed something. How can I submit to the Trump Capsule?{' '}
      </SubHeader>
      <Text>
        Given the massive number of insane things that come out of The Donald's
        mouth and administration we are bound to miss a few. If you see we're
        missing something{' '}
        <StyledAnchor
          onClick={() =>
            track(EVENTS.CLICK_CONTACT_LINK, {
              source: SOURCES.ABOUT
            })
          }
          href="mailto:collusion@trumpcapsule.com?subject=Trump Capsule Feedback"
        >
          let us know
        </StyledAnchor>!
      </Text>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/views/About.js